import React, { useEffect, useState, useRef } from 'react'
import {
  HashRouter as Router,
  Switch,
  useLocation,
  matchPath,
  Redirect,
} from 'react-router-dom'
import ReactGA from 'react-ga'
import { Menu, Route as RouteG, Loader } from '../components'
import { Artists, Home, Info } from '../pages'
import routesFactory from './routesFactory'
import artists from './artists'

const intros = artists
  .map((artist) => (
    artist.jobs.map((job) => [
      `${artist.path}${job.path}`,
      `${artist.path}${job.path}/info`,
    ])
  ))
  .flat(2)

// const whatsappPath = '/mexa/so-anitta-pode-add/play'
// const routesWithSound = ['/', '/artists', '/info', whatsappPath].concat(intros)
const routesWithSound = ['/', '/artists', '/info'].concat(intros)
const pathsWithSound = `(${routesWithSound.join('|')})?`

// TODO extract to component
const Sound = () => {
  const location = useLocation()
  const audio = useRef()
  const [canReproduce, setCanReproduce] = useState(false)

  // useEffect(() => {
  //   const isWhatsapp = matchPath(location.pathname, {
  //     path: whatsappPath,
  //     exact: true,
  //   })
  //   audio.current.volume = isWhatsapp ? 0.2 : 1
  // }, [location.pathname, audio])

  useEffect(() => {
    audio.current.volume = 1

    const isHome = matchPath(location.pathname, {
      path: pathsWithSound,
      exact: true,
    })

    const isPaused = audio.current.paused
    if (canReproduce) {
      if (isHome) {
        if (isPaused) {
          audio
            .current
            .play()
            .catch(() => console.warn('failed to play background sound'))
        }
      } else {
        if (!isPaused) audio.current.pause()
      }
    }

    const onClick = () => {
      if (canReproduce) return

      audio
        .current
        .play(true)
        .catch(() => console.warn('failed to play background sound'))
      setCanReproduce(true)
    }

    window.addEventListener('click', onClick)

    return () => {
      window.removeEventListener('click', onClick);
    }
  }, [canReproduce, location.pathname, audio])

  return (
    <audio
      ref={audio}
      style={{ visibility: 'hidden' }}
      src="/assets/sounds/ambient.mp3"
      loop
    />
  )
}

const Routes = () => {
  ReactGA.initialize('G-CLJVRP5DRJ');
  ReactGA.pageview(window.location.pathname + window.location.search);
  
  return (
    <Router>
      <RouteG path="/" Screen={Home} forceHistory />
      <Sound />

      <Switch>
        <RouteG path="/artists" Screen={Artists} />
        <RouteG path="/info">
          <Artists />
          <Info />
        </RouteG>
        {routesFactory()}
        <RouteG path="*" Screen={() => <Redirect to="/" />} />
      </Switch>

      <Menu />
      <Loader fullscreen />
    </Router>
  );
}

export default Routes
